import { supabase } from '@/lib/supabase';
import { toUserMessage } from '@/lib/errors';
import { ok, err, type ApiResponse } from './_base';

// ═══════════════════════════════════════════════════════════════════════════
// Audit log (auditoria_cambios) — visor para APEX / PARTNER
// ═══════════════════════════════════════════════════════════════════════════

export interface AuditoriaRow {
  id: string;
  created_at: string;
  entidad: string;
  entidad_id: string | null;
  operacion: string;
  diff: Record<string, unknown> | null;
  user_id: string | null;
  user_nombre: string | null;
  user_email: string | null;
  total_count: number;
}

export interface AuditoriaFacet {
  entidad: string;
  operacion: string;
  cnt: number;
}

export interface ListAuditoriaFilters {
  empresaId: string;
  entidad?: string;
  operacion?: string;
  desde?: string; // ISO timestamptz
  hasta?: string;
  limit?: number;
  offset?: number;
}

export async function listAuditoria(
  filters: ListAuditoriaFilters,
): Promise<ApiResponse<{ rows: AuditoriaRow[]; total: number }>> {
  const { data, error } = await supabase.rpc('list_auditoria_cambios', {
    p_empresa_id: filters.empresaId,
    p_entidad: filters.entidad ?? undefined,
    p_operacion: filters.operacion ?? undefined,
    p_desde: filters.desde ?? undefined,
    p_hasta: filters.hasta ?? undefined,
    p_limit: filters.limit ?? 100,
    p_offset: filters.offset ?? 0,
  });
  if (error) return err(error.code ?? 'RPC_FAILED', toUserMessage(error));
  const rows = (data ?? []) as AuditoriaRow[];
  const total = rows.length > 0 ? Number(rows[0]!.total_count) : 0;
  return ok({ rows, total });
}

export async function listAuditoriaFacetas(
  empresaId: string,
): Promise<ApiResponse<AuditoriaFacet[]>> {
  const { data, error } = await supabase.rpc('list_auditoria_facetas', {
    p_empresa_id: empresaId,
  });
  if (error) return err(error.code ?? 'RPC_FAILED', toUserMessage(error));
  return ok((data ?? []) as AuditoriaFacet[]);
}
